import type {
  NotesQuery,
  NotesQueryVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import hirerGraphqlClient from './client';
import { query } from './schema/queryApplicationNotes';

const fetchApplicationNotes = async (prospectId: string) => {
  const { data } = await hirerGraphqlClient.query<
    NotesQuery,
    NotesQueryVariables
  >({
    variables: { prospectId },
    query,
  });
  if (data === null) {
    throw new Error('error in rendering notes');
  }
  const notes = data.applicationNotes.nodes
    .map((note: Record<string, any>) => ({
      id: note.id,
      content: note.content,
      createdUser: note.createdUser,
      createdDate: note.createdDate,
      createdUserId: note.createdUserId,
    }))
    .sort((note1: Record<string, any>, note2: Record<string, any>) =>
      (note2.createdDate as string).localeCompare(note1.createdDate as string),
    );
  return notes;
};

export default fetchApplicationNotes;
